// reducers/sseReducer.js
import { LOGOUT_USER } from "../types/authTypes";
import { GET_CHALLENGE_PROGRESS } from "../types/challengeTypes";

const initialState = {
  progress: []
};

const handleClaim = (state, payload) => {
  const { challengeId, milestoneId } = payload;

  return state.progress.map((c) => {
      if (c.id !== challengeId) return c; // Return unchanged challenges

      return {
          ...c,
          progress: c.progress.map((p) =>
              ({
                  ...p,
                  claimed_milestones: [...(p.claimed_milestones || []), milestoneId]
              })
          ),
      };
  });
};


const sseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHALLENGE_PROGRESS:
      return {
        ...state,
        progress: action.payload,
      };

    case 'CLAIM_SUCCESS':
      return {
        ...state,
        progress: [...handleClaim(state, action.payload)],
      };

    case LOGOUT_USER:
      return initialState;

    default:
      return state;
  }
};

export default sseReducer;
